import { IBidirectionalTemplate } from "../interface";

export const BidirectionalTemplateEmpty: IBidirectionalTemplate = {
    name: "",
    description: "",
    questions: [],
    expiration: "never-expires",
    whoCanEvaluate: [],
    whoWillBeEvaluated: [],
}